let inputIds = 0;
export function getInputsIndexCounter() {
  return inputIds++;
}
//# sourceMappingURL=inputs-counter.js.map
